import { SuperModel } from './super-model.model';
import { EFsContentType } from './fs-item.enum';
import { Tag } from './tag.model';

export class FsItem extends SuperModel {
  name: string;
  contentType: EFsContentType;
  fileType: string;
  fileSize: string;
  isFolder: boolean;
  tags: Tag[];

  // spsearch properties
  filePath: string;
  title: string;

  createdFrom?: Date;
  createdTo?: Date;
  modifiedFrom?: Date;
  modifiedTo?: Date;

  constructor(data: Partial<FsItem> = {}) {
    super(data);

    if (this.title) {
      this.name = this.title;
    }

    if (data.tags && Array.isArray(data.tags)) {
      this.tags = data.tags.map(tag => new Tag(tag));
    } else {
      this.tags = [];
    }
  }

  get serialised() {
    if (this.createdFrom) {
      this.createdFrom.setHours(0, 0, 0);
    }
    if (this.createdTo) {
      this.createdTo.setHours(23, 59, 0);
    }
    if (this.modifiedFrom) {
      this.modifiedFrom.setHours(0, 0, 0);
    }
    if (this.modifiedTo) {
      this.modifiedTo.setHours(23, 59, 0);
    }
    return {
      id: this.id,
      name: this.name,
      contentType: this.contentType,
      fileType: this.fileType,
      fileSize: this.fileSize,
      isFolder: this.isFolder,
      createdFrom: this.createdFrom,
      createdTo: this.createdTo,
      modifiedFrom: this.modifiedFrom,
      modifiedTo: this.modifiedTo,
      createdBy: this.createdBy,
      modifiedBy: this.modifiedBy,
      tags: this.tags,
    };
  }

  get tagsList() {
    return this.tags ? this.tags.map(tag => tag.title).join(', ') : '';
  }
}
